module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('item-form', {
    attrs: {
      "create": true
    },
    on: {
      "saved": _vm.editItem
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3e4c212"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/items/ItemCreate.vue
// module id = 580
// module chunks = 0